import { toast } from 'react-hot-toast';

import { logInWithOauth } from '@utils/backend-api/oauth';
import { OauthLoginParams } from '@utils/backend-api/oauth';

const useOauthLogin = () => {
  const login = async (values: OauthLoginParams) => {
    try {
      const response = await logInWithOauth(values);
      window.location.href = response.redirect_url;
    } catch (error) {
      toast.error(error.message);
    }
  };

  return { login };
};

export default useOauthLogin;
